module.exports = __webpack_public_path__ + "static/media/ic_given_flexibility_green.0134de78.svg";